import script from "./LegalView.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalView.vue?vue&type=script&setup=true&lang=js"

import "./LegalView.vue?vue&type=style&index=0&id=6e1a87f4&lang=css"

const __exports__ = script;

export default __exports__